export default __webpack_public_path__ + "static/media/dinner4.aceacb1f.png";